import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		showPartnerListDrawer: {
			left: 0,
			transition: 'left .3s ease-in',
			position: 'absolute',
			margin: theme.spacing(2),
			zIndex: 5,
			'&:hover': {
				'& svg': {
					fill: 'white',
				},
			},
			'& svg': {
				fill: 'white',
			},
			display: 'none',
			[theme.breakpoints.up('lg')]: {
				display: 'flex',
			},
		},
		showMapFullScreen: {
			right: 0,
			transition: 'right .3s ease-in',
			position: 'absolute',
			margin: theme.spacing(2),
			zIndex: 5,
			'&:hover': {
				'& svg': {
					fill: 'white',
				},
			},
			'& svg': {
				fill: 'white',
			},
			display: 'none',
			[theme.breakpoints.up('lg')]: {
				display: 'flex',
			},
		},
		partnerListHidden: {
			left: -theme.spacing(8),
		},
		mapHidden: {
			right: -theme.spacing(8),
		},
	}),
);
